export default {
  setLoadBtn(state, data) {
    state.loadBtn = data;
  },

  setSocialNetworks(state, data) {
    state.socialNetworks = data;
  },

  setDate(state, data) {
    state.date = data;
  },

  setLanguage(state, data) {
    state.language = data;
  },

  setChangeLanguage(state, data) {
    state.changeLanguage = data;
  },

  setMenuPosition(state, data) {
    state.menuPosition = data;
  },

  setHeaderMenu(state, data) {
    state.headerMenu = data;
  },

  setFooterMenu(state, data) {
    state.footerMenu = data;
  },


  setConfig(state, data) {
    state.config = data;
  },

  setAboutUs(state, data) {
    state.aboutUs = data;
  },

  setContactUs(state, data) {
    state.contactUs = data;
  },

  setCaptcha(state, data) {
    state.captcha = data;
  },

  getCategories(state, data) {
    state.categories = data;
  },

  setBlogs(state, data) {
    state.blogs = data;
  },
  setBlog(state, data) {
    state.blog = data;
  },

  setComments(state, data) {
    state.comments = data;
  },
  setCommentsLength(state, data) {
    state.commentsLength = data;
  },

  setMedias(state, data) {
    state.medias = data;
  },
  setMedia(state, data) {
    state.media = data;
  },
  setMediaGallery(state, data) {
    state.mediaGallery = data;
  },

  setMediaComments(state, data) {
    state.mediaComments = data;
  },
  setMediaCommentsLength(state, data) {
    state.mediaCommentsLength = data;
  },

  setPhotos(state, data) {
    state.photos = data;
  },
  setPhoto(state, data) {
    state.photo = data;
  },
  setPhotosGallery(state, data) {
    state.photosGallery = data;
  },

  setPhotoComments(state, data) {
    state.photoComments = data;
  },
  setPhotoCommentsLength(state, data) {
    state.photoCommentsLength = data;
  },

  setBooks(state, data) {
    state.books = data;
  },
  setBookGallery(state, data) {
    state.bookGallery = data;
  },

  setBookComments(state, data) {
    state.bookComments = data;
  },
  setBookCommentsLength(state, data) {
    state.bookCommentsLength = data;
  },

  setPublishers(state, data) {
    state.publishers = data;
  },

  setAuthors(state, data) {
    state.authors = data;
  },

  setSounds(state, data) {
    state.sounds = data;
  },
  setSound(state, data) {
    state.sound = data;
  },
  
  setSoundGallery(state, data) {
    state.soundGallery = data;
  },

  setSoundComments(state, data) {
    state.soundComments = data;
  },
  setSoundCommentsLength(state, data) {
    state.soundCommentsLength = data;
  },

  setBookContents(state, data) {
    state.bookContents = data;
  },

  setBookDetails(state, data) {
    state.bookDetails = data;
  },

  setBookPublisher(state, data) {
    state.bookPublisher = data;
  },

  setSearch(state, data) {
    state.search = data;
  },

};
